(() => {
  angular
    .module('complianceFrameworkApp.complianceFramework')
    .controller('NewStaffUserController', NewStaffUserController);

  /* ngInject */
  function NewStaffUserController($state, $stateParams, Flash, formErrorsService, sessionService, staffService) {
    const vm = this;

    angular.extend(vm, formErrorsService);

    vm.saveStaffUser = saveStaffUser;
    vm.staffUser = {};
    vm.staffUserForm = {};

    function saveStaffUser(staff) {
      staffService(sessionService.getAuthToken()).save({staff}, _createUserSuccess, _saveUserFailure);
    }

    function _createUserSuccess(response) {
      Flash.create('success', 'The staff user was successfully created.');
      $state.go('application.compliance_framework.edit_staff_user', {id: response.id});
    }

    function _saveUserFailure(response) {
      vm.setFormErrors(vm.form, response);
      Flash.create('error', 'An error occurred with the submission. Please correct the errors on the form and resubmit.');
    }
  }
})();
